import { FC } from 'react';
import { Flex, Divider, Text } from '@chakra-ui/react';
export interface CbOrDividerProps {
  minWidth?: string;
}
export const CbOrDivider: FC<CbOrDividerProps> = ({
  minWidth
}) => {
  return <Flex flexDirection="row" alignItems="center" minWidth={minWidth} width="100%" data-sentry-element="Flex" data-sentry-component="CbOrDivider" data-sentry-source-file="CbOrDivider.tsx">
      <Divider borderWidth="1px" borderColor="cloud.500" data-sentry-element="Divider" data-sentry-source-file="CbOrDivider.tsx" />
      <Text color="text.secondary" marginX={3} fontWeight={700} data-sentry-element="Text" data-sentry-source-file="CbOrDivider.tsx">
        {'Or'}
      </Text>
      <Divider borderWidth="1px" borderColor="cloud.500" data-sentry-element="Divider" data-sentry-source-file="CbOrDivider.tsx" />
    </Flex>;
};